exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-login-button {\n  margin: 5px; }\n  .social-login-button.google, .social-login-button.facebook, .social-login-button.microsoft, .social-login-button.twitter, .social-login-button.github, .social-login-button.linkedin {\n    width: 192px;\n    text-transform: none;\n    color: #FFFFFF;\n    font-size: 13px; }\n    .social-login-button.google md-icon, .social-login-button.facebook md-icon, .social-login-button.microsoft md-icon, .social-login-button.twitter md-icon, .social-login-button.github md-icon, .social-login-button.linkedin md-icon {\n      color: #FFFFFF;\n      margin: 0 8px 0 0; }\n  .social-login-button.google {\n    background-color: #D73D32; }\n  .social-login-button.facebook {\n    background-color: #3f5c9a; }\n  .social-login-button.microsoft {\n    background-color: #2672EC; }\n  .social-login-button.twitter {\n    background-color: #55ACEE; }\n  .social-login-button.github {\n    background-color: #444444; }\n  .social-login-button.linkedin {\n    background-color: #007BB6; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/+login/sociallogin/social-login.component.scss
// module id = ../../../../../src/app/+login/sociallogin/social-login.component.scss
// module chunks = main